// GQL
import { client } from '../client';
import {
  GET_CONCESSION_BY_ID,
  GET_ROAD_BY_ID,
} from '../queries/geoPositions/roads';
import {
  GET_CAPITOL_BY_ID,
  GET_CLASSIFICATION_BY_ID_OR_ROID,
  GET_SUB_CAPITOL_BY_ID,
} from '../queries/orders/predefinedData';
import { GET_TEAM_BY_ID } from '../queries/users';

// Static data
import { laneLabel, trackLabel } from '../../utils/catalogLabels';

export const selectDataForEditCampaignSummary = async (formData: FormData) => {
  const id = formData.get('id');
  const roid = formData.get('roid');
  const operator = formData.get('operator');
  const registerInitDate = formData.get('registerInitDate');
  const sendStatus = formData.get('sendStatus');
  const concessionId = formData.get('concession');
  const roadId = formData.get('road');
  const classificationId = formData.get('classification');
  const capitolId = formData.get('capitol');
  const subCapitolId = formData.get('subCapitol');

  const teamIdRaw = formData.get('teamRelationships') || formData.get('team') || formData.get('teams');
  const teamIds: string[] = teamIdRaw
    ? String(teamIdRaw).split(',').map((s) => s.trim()).filter(Boolean)
    : [];

  const [
    {
      data: { concession },
    },
    {
      data: { road },
    },
  ] = await Promise.all([
    client.query({
      query: GET_CONCESSION_BY_ID,
      variables: {
        id: concessionId,
      },
    }),
    client.query({
      query: GET_ROAD_BY_ID,
      variables: {
        id: roadId,
      },
    }),
  ]);

  let teamName = '';
  if (teamIds.length > 0) {
    try {
      const teamNames = await Promise.all(
        teamIds.map(async (id) => {
          const { data: { team } } = await client.query({
            query: GET_TEAM_BY_ID,
            variables: { id },
          });
          return team?.name || '';
        })
      );
      teamName = teamNames.filter(Boolean).join(', ');
    } catch {}
  }

  const [
    {
      data: { classification },
    },
    {
      data: { capitol },
    },
    {
      data: { subCapitol },
    },
  ] = await Promise.all([
    client.query({
      query: GET_CLASSIFICATION_BY_ID_OR_ROID,
      variables: {
        id: classificationId,
      },
    }),
    client.query({
      query: GET_CAPITOL_BY_ID,
      variables: {
        id: capitolId,
      },
    }),
    client.query({
      query: GET_SUB_CAPITOL_BY_ID,
      variables: {
        id: subCapitolId,
      },
    }),
  ]);

  const classificationPass = classification.name;
  const capitolPass = capitol.name;
  const subCapitolPass = subCapitol.name;

  const city = formData.get('city');
  const trackValue = formData.get('track');
  const direction = formData.get('direction');
  const margin = formData.get('margin');
  const laneValue = formData.get('lane');
  const pkInit = formData.get('pkInit');
  const pkEnd = formData.get('pkEnd');
  const description = formData.get('description');
  const specialTag = formData.get('specialTag');
  const campaign = formData.get('campaign');
  const changesCampaign = formData.get('changesCampaign');

  const roidParsed = () => {
    return roid?.toString().split(',');
  };

  return {
    id,
    roid: roidParsed(),
    operator,
    registerInitDate,
    sendStatus,
    concession: concession?.name,
    city,
    road: road?.name,
    track: trackLabel(trackValue as string | null),
    direction,
    margin,
    lane: laneLabel(laneValue as string | null),
    pkInit,
    pkEnd,
    description,
    specialTag,
    classification: classificationPass,
    capitol: capitolPass,
    subCapitol: subCapitolPass,
    team: teamName,
    campaign: campaign,
    changesCampaign: JSON.parse(changesCampaign as string),
  };
};
